import { LicenseInfo, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterLuxon } from '@mui/x-date-pickers-pro/AdapterLuxon';

import { MUILicenseKey } from 'helpers/env';

// Setting up MUI license
LicenseInfo.setLicenseKey(MUILicenseKey);

const MUILicenseConfig = ({ children }: { children: React.ReactNode }) => (
  <LocalizationProvider dateAdapter={AdapterLuxon}>
    {children}
  </LocalizationProvider>
);

export default MUILicenseConfig;
